export default "__VITE_ASSET__CI7Ovad2__"